class CustomerService {
  constructor(config, httpDim) {
    this.config = config;
    this.httpDim = httpDim;
    this.customerUrl = `${this.config.apiRoot}/customers`;
  }

  loadAgentConfig(customerId) {
    let url = this.config.apiRoot + '/agentConfigs?customerId=' + customerId;
    return this.httpDim.get(url,this.config);
  }

  getCustomers(offset,limit,searchValue, includeManual = false ,showContentLoader = true) {
    let methodHasToShowContentLoader = showContentLoader;
    let config = this.config;
    let url = `${this.customerUrl}?offset=${offset}&limit=${limit}&searchValue=${searchValue}&includeManual=${includeManual}`;
    return this.httpDim.get(url, config, methodHasToShowContentLoader);
  }

  putCustomer(customer) {
    return this.httpDim.put(this.customerUrl, customer);
  }

  createCustomer(customer) {
    return this.httpDim.post(this.customerUrl, customer);
  }

  getEngradeDistrict(districtCode) {
    let url = `${this.config.apiRoot}/engrade/districts/${districtCode}`;
    return this.httpDim.get(url);
  }

  getConnectEdCustomer(purchasingAccountNumber) {
    let url = `${this.config.apiRoot}/connectEd/customers/${purchasingAccountNumber}`;
    return this.httpDim.get(url);
  }

  getOrganization(orgXid) {
    let url = `${this.config.apiRoot}/organizations/${orgXid}`;
    return this.httpDim.get(url);
  }
}

CustomerService.$inject = ['config','httpDim'];

export
default CustomerService;



// WEBPACK FOOTER //
// ./app/common/customer/customer.service.js